import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Checkbox } from '@mui/material';
import { TableCell, TableRow } from '@mui/material';
import { IconButton } from '@totalsoft/rocket-ui';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import FlexBox from 'components/common/FlexBox';

const IncomeSourceItem = ({ data, onDelete }) => {
  const { t } = useTranslation();
  const historyContext = useHistoryWithContext();

  const handleEdit = useCallback(() => {
    historyContext.push(`/incomeSources/${data.id}`);
  }, [historyContext, data]);

  return (
    <TableRow>
      <TableCell>{data.orderNo}</TableCell>
      <TableCell>{data.code}</TableCell>
      <TableCell>{data.name}</TableCell>
      <TableCell>{data.incomeSourceArea}</TableCell>
      <TableCell align='center'>
        <Checkbox disabled={true} size='small' checked={Boolean(data.isActive)} />
      </TableCell>
      <TableCell>
        <FlexBox gap={0.5} justifyContent='end'>
          <IconButton type='edit' size='small' variant='text' color='primary' tooltip={t('IncomeSources.Edit')} onClick={handleEdit} />
          <IconButton
            type='delete'
            size='small'
            variant='text'
            color='primary'
            tooltip={t('IncomeSources.Delete')}
            onClick={() => onDelete(data.id)}
          />
        </FlexBox>
      </TableCell>
    </TableRow>
  );
};

IncomeSourceItem.propTypes = {
  data: PropTypes.object.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default IncomeSourceItem;
